module.exports = __webpack_public_path__ + "media/buy-now/bag6-6b9dbb8c.png";